import { createWebHashHistory, createRouter } from "vue-router";

import Index from "@/views/index";
import Detail from "@/views/detail";

const routes = [
    {
        path: "/",
        component: Index
    },
    {
        path: "/detail/:id",
        component: Detail
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/"
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
